import config from '../config';
import { getCsrfToken, clearCsrfToken } from './csrf';

let authenticated = false;
const base = `${config.USER_ONBOARDING}/UAM`;
export const authService = {
  async initializeAuthentication(navigate, showPinModalCallback) {
    // Discard old URL tokens from any bookmarked or legacy redirect.
    const url = new URL(window.location.href);
    if (url.searchParams.has('jwtToken') || url.searchParams.has('SAML_SESSION')) {
      url.searchParams.delete('jwtToken'); url.searchParams.delete('SAML_SESSION');
      window.history.replaceState({}, '', url.pathname + url.search + url.hash);
    }
    localStorage.removeItem('user-access-token');
    const sessionResponse = await fetch(`${base}/api/auth/session`, {
      credentials: 'include', cache: 'no-store'
    });
    if (!sessionResponse.ok) {
      authenticated = false; localStorage.removeItem('user-onboard-data');
      window.dispatchEvent(new CustomEvent('auth-error', { detail: { status: sessionResponse.status, message: 'UAM session is unavailable. Please sign in again through the portal.' } }));
      return;
    }
    const session = await sessionResponse.json();
    const response = await fetch(`${base}/api/v1/onboard-users/getSSOUserInfo?username=${encodeURIComponent(session.username)}`, {
      credentials: 'include', cache: 'no-store'
    });
    if (!response.ok) { authenticated = false; window.dispatchEvent(new CustomEvent('auth-error', { detail: { status: response.status, message: 'Unable to load UAM access. Please sign in again.' } })); return; }
    const data = await response.json();
    if (!data.onboardingAllowed) { authenticated = false; window.dispatchEvent(new CustomEvent('auth-error', { detail: { status: 403, message: 'UAM access is not authorized for this account.' } })); return; }
    localStorage.setItem('user-onboard-data', JSON.stringify(data));
    if (session.twoFaRequired) {
      authenticated = false;
      showPinModalCallback(data);
      return;
    }
    authenticated = true;
    // Only select a landing page when visiting the application root.
    // Preserve deep links, refreshes, and all sidebar menu destinations.
    const currentPath = window.location.pathname.replace(/\/+$/, '') || '/';
    if (currentPath === '/' || currentPath === '/UamUI') {
      navigate(data?.isAdmin === 'Y' ? '/admin/dashboard' : '/new-user/create', { replace: true });
    }
  },
  isAuthenticated() { return authenticated; },
  markAuthenticated() { authenticated = true; },
  async logout(redirectUrl = '/') {
    authenticated = false;
    try {
      const csrf = await getCsrfToken();
      const result = await fetch(`${base}/api/auth/logout`, {
        method: 'POST', credentials: 'include', headers: { 'X-CSRF-TOKEN': csrf }, cache: 'no-store'
      });
      if (!result.ok) throw new Error('Server logout was not confirmed');
    } catch (e) {
      // Do not navigate to a login page while the server may still accept the session.
      authenticated = false;
      window.alert('Sign out could not be confirmed. Please retry.');
      return false;
    }
    clearCsrfToken();
    localStorage.removeItem('user-access-token');
    localStorage.removeItem('user-onboard-data');
    localStorage.removeItem('fullName');
    window.location.assign(redirectUrl);
    return true;
  },
  setupLogoutOnTabClose() {},
  logoutOnClose() {},
};
